"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IFrameBuilder_1 = __importDefault(require("./IFrameBuilder"));
var IFrameOgBuilder = /** @class */ (function (_super) {
    __extends(IFrameOgBuilder, _super);
    function IFrameOgBuilder(openGraphProvider) {
        var _this = _super.call(this) || this;
        _this._openGraphProvider = openGraphProvider;
        return _this;
    }
    /**
     * Compose iframe URL with og values
     * @param config
     */
    IFrameOgBuilder.prototype.composeIframeUrl = function (config) {
        var iframeURL = _super.prototype.composeIframeUrl.call(this, config);
        return this.addOgParameters(iframeURL);
    };
    /**
     * Adds OG parameters to URL
     * @param iframeURL
     */
    IFrameOgBuilder.prototype.addOgParameters = function (iframeURL) {
        var _this = this;
        var ogProperties = ["title", "image"];
        ogProperties.forEach(function (property) {
            iframeURL += "&" + property + "=" + _this._openGraphProvider.get(property);
        });
        return iframeURL;
    };
    return IFrameOgBuilder;
}(IFrameBuilder_1.default));
exports.default = IFrameOgBuilder;
